import { Table } from "antd";
import React, { useEffect, useState } from "react";
import FilterModal from "./FilterModal";
import MaterialIcon from "material-icons-react";
import { useDispatch, useSelector } from "react-redux";
import svg38 from "../../assets/svg/svg38.svg";
import { dateForHumans } from "../../utils";
import PayoutHistoryModal from "./modal/PayoutHistoryModal";
import downloadSvg from "../../assets/svg/svg65.svg";


function PayoutHistory() {
  const { payoutHistoryCount, payoutHistoryData } = useSelector(
    (state) => state.auth
  );
  const dispatch = useDispatch();
  const [formData, setFormData] = useState({});
  const [isModalOpen, setIsModalOpen] = useState(false);
  const showModal = () => {
    setIsModalOpen(true);
  };

  const [open, setopen] = useState(false);
  const showModalHistory = () => {
    setopen(true);
  };

  async function handleCancel() {
    await setopen(false);
  }

  const handleClearFilters = async (page, size) => {
    await setFormData({});
    // await dispatch(
    //   fetchPayoutHistory({
    //     url: "api/v2/ndovupay/withdrawals",
    //     withDrawDateFrom: getDate90DaysAgo(),
    //   })
    // );
  };

  const [pageIndex, setPageIndex] = useState(0);
  const [pageSize, setPageSize] = useState(10);

  async function fetchPayoutHistoryData(page, size) {}

  useEffect(() => {
    fetchPayoutHistoryData();
  }, []);

  const columns = [
    {
      title: "Amount",
      dataIndex: "withDrawAmount",
    },
    {
      title: "Payout Date",
      render: (item) => {
        return <div>{dateForHumans(item)}</div>;
      },
      dataIndex: "withDrawCreatedDate",
    },
    {
      title: "Status",
      dataIndex: "withDrawStatus",
      render: (item) => {
        return (
          <div
            className={`${
              item === "FAILED" ? "bg-[#FFA500]" : "bg-darkGreen"
            }  text-[#FFf]  inline-block rounded-[5px] px-2 py-1 w-auto`}
          >
            {item}
          </div>
        );
      },
    },
    {
      title: "Phone Number",
      dataIndex: "withDrawPhoneNumber",
    },
    {
      title: "Withdrawal Email",
      dataIndex: "withDrawCreatedByEmail",
    },
  ];

  return (
    <div>
      <div className="product_sub !text-[18px] mt-3">Payout History</div>
      <div className="flex items-center justify-between ">
      <div className="mt-[.31rem] flex items-center gap-x-10">
        <div className="flex items-center">
          <span>
            {" "}
            <button
              onClick={showModal}
              type="button"
              className={`bg-transparent flex items-center gap-x-'1' ${
                Object?.keys(formData)?.length > 0
                  ? "!text-[#5688E5]"
                  : "inherit"
              }`}
            >
              <MaterialIcon color="#141414" icon="filter_list" />
              Filters
            </button>
          </span>
          {Object?.keys(formData)?.length > 0 && (
            <span className="flex items-center text-[#5688E5] cursor-pointer ml-1">
              :{Object?.keys(formData)?.length}
              <img src={svg38} alt="svg38" onClick={handleClearFilters} />
            </span>
          )}
        </div> 
      </div>
      <div className="w-[280px]">
        <button className="cstm-btn flex items-center gap-x-5" onClick={showModalHistory}>
          <img src={downloadSvg} alt="downloadSvg"/>
          Download Statement</button>
      </div>
      </div>
   

      <Table
        dataSource={payoutHistoryData}
        columns={columns}
        className="mt-[.31rem]  mb-[10rem] w-full"
        scroll={{
          x: 800,
        }}
        pagination={{
          position: ["bottomCenter"],
          current: pageIndex + 1,
          total: payoutHistoryCount,
          pageSize: pageSize,
          onChange: (page, size) => {
            setPageIndex(page - 1);
            setPageSize(size);
            fetchPayoutHistoryData(page - 1, size);
          },
          showSizeChanger: false,
          hideOnSinglePage: true,
        }}
        rowKey={(record) => record?.withDrawId}
      />

      <FilterModal
        isModalOpen={isModalOpen}
        setIsModalOpen={setIsModalOpen}
        formData={formData}
        setFormData={setFormData}
      />
      <PayoutHistoryModal
        open={open}
        handleCancel={handleCancel} 
      />
    </div>
  );
}

export default PayoutHistory;
